import type { LayerPattern } from '../patterns/index';
import { LAYER_SETTINGS_TYPES } from '../constants';
import { DevelopDiagramsSvg } from './icons';

export const developDiagrams: LayerPattern = {
    id: 'developDiagrams',
    key: 'well_debit',
    title: 'Диаграммы разработки',
    icon: DevelopDiagramsSvg,
    settings: [
        {
            title: 'Типы диаграмм',
            key: 'debitType',
            type: LAYER_SETTINGS_TYPES.SELECT,
            options: [
                { value: '0', label: 'Текущее состояние (дебит.)' },
                { value: '1', label: 'Текущее состояние (ср. сут.)' },
                { value: '2', label: 'Текущее состояние (добыча)' },
                { value: '3', label: 'Накопленные отборы' },
            ],
            defaultValue: 2,
            level: 0,
        },
        {
            title: 'Нефть/Жидкость',
            key: 'liquidProductionVisible',
            type: LAYER_SETTINGS_TYPES.GROUP_CHECKED,
            defaultValue: true,
            level: 0,
        },
        {
            title: 'Заливка нефть',
            key: 'liquidProductionOilBackroundColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#ff641400',
            level: 1,
        },
        {
            title: 'Заливка вода',
            key: 'liquidProductionWaterBackroundColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#ff07beb5',
            level: 1,
        },
        {
            title: 'Диаметр (коэф.)',
            key: 'liquidProductionScaleFactor',
            type: LAYER_SETTINGS_TYPES.FLOAT,
            defaultValue: 1.0,
            level: 1,
        },

        {
            title: 'Закачка',
            key: 'injectionProductionVisible',
            type: LAYER_SETTINGS_TYPES.GROUP_CHECKED,
            defaultValue: true,
            level: 0,
        },

        {
            title: 'Заливка',
            key: 'injectionProductionBackroundColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#ff00ff00',
            level: 1,
        },
        {
            title: 'Диаметр (коэф.)',
            key: 'injectionProductionScaleFactor',
            type: LAYER_SETTINGS_TYPES.FLOAT,
            defaultValue: 1.0,
            level: 1,
        },

        {
            title: 'Газ',
            key: 'gasProductionVisible',
            type: LAYER_SETTINGS_TYPES.GROUP_CHECKED,
            defaultValue: true,
            level: 0,
        },

        {
            title: 'Заливка растворенный',
            key: 'gasProductionGasBackroundColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#ffaaaa00',
            level: 1,
        },
        {
            title: 'Заливка из шапки',
            key: 'gasProductionGasCapBackroundColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#ff50af50',
            level: 1,
        },
        {
            title: 'Заливка свободный',
            key: 'gasProductionGasNaturalBackroundColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#ffaf50af',
            level: 1,
        },
        {
            title: 'Диаметр (коэф.)',
            key: 'gasProductionScaleFactor',
            type: LAYER_SETTINGS_TYPES.FLOAT,
            defaultValue: 1.0,
            level: 1,
        },

        {
            title: 'ТУТ',
            key: 'tutProductionVisible',
            type: LAYER_SETTINGS_TYPES.GROUP_CHECKED,
            defaultValue: true,
            level: 0,
        },

        {
            title: 'Заливка нефть',
            key: 'tutProductionOilBackroundColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#ffaaaa00',
            level: 1,
        },
        {
            title: 'Заливка газ из шапки',
            key: 'tutProductionGascapBackroundColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#ff00ff00',
            level: 1,
        },
        {
            title: 'Заливка газ свободный',
            key: 'tutProductionGasTutBackroundColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#ff0000ff',
            level: 1,
        },
        {
            title: 'Заливка газ накопленный',
            key: 'tutProductionGascondBackroundColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#ffffff00',
            level: 1,
        },
        {
            title: 'Заливка газ закачанный',
            key: 'tutProductionGasnaturalTutBackroundColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#ff00ffff',
            level: 1,
        },
        {
            title: 'Диаметр (коэф.)',
            key: 'tutProductionScaleFactor',
            type: LAYER_SETTINGS_TYPES.FLOAT,
            defaultValue: 1.0,
            level: 1,
        },
    ],
};
